import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import React from "react";
import { Navigate, Route, Routes } from "react-router";

import { Login } from "@/pages/Login";
import AppLayout from "@/app/AppLayout";
import CalculationAnalysis from "@/pages/CalculationAnalysis/CalculationAnalysis";
import CalculationInput from "@/pages/CalculationInput/CalculationInput";
import CalculationDetail from "@/pages/CalculationDetail/CalculationDetail";
import OperationalData from "@/pages/OperationalData/components";
import { routePaths, routeSegments } from "@/constants/routePaths";
import AuthenticatedNotFound from "./AuthenticatedNotFound";

const AppRoutes: React.FC = () => (
  <>
    <AuthenticatedTemplate>
      <Routes>
        <Route path={routePaths.home} element={<AppLayout displayNavigation />}>
          <Route
            index
            element={<Navigate replace to={routeSegments.calculations} />}
          />
          <Route
            path={routeSegments.calculations}
            element={<CalculationInput />}
          />
          <Route
            path={routeSegments.calculationDetail}
            element={<CalculationDetail />}
          />
          <Route
            path={routeSegments.calculationAnalysis}
            element={<CalculationAnalysis />}
          />
          <Route
            path={routeSegments.operationalData}
            element={<OperationalData />}
          />
          <Route path={"*"} element={<AuthenticatedNotFound />} />
        </Route>
      </Routes>
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
      <Routes>
        <Route
          path={routePaths.home}
          element={<AppLayout displayNavigation={false} />}
        >
          <Route index element={<Login />} />
          <Route
            path={"*"}
            element={<Navigate replace to={routePaths.home} />}
          />
        </Route>
      </Routes>
    </UnauthenticatedTemplate>
  </>
);

export default React.memo(AppRoutes);
